export default "__VITE_ASSET__BhZDHz7P__"